export enum TreatmentWarning{
	RID_CHANGED = 'RID_CHANGED',
	GLOBAL_MEAS_ANSWER_CHANGED = 'GLOBAL_MEAS_ANSWER_CHANGED',
	LI_SELECTED = 'LI_SELECTED',
	APP_LIST_CHANGED = 'APP_LIST_CHANGED',
	GLOBAL_MEAS_LIST_CHANGED = 'GLOBAL_MEAS_LIST_CHANGED',
}
